import React from "react";
import { Row } from "antd";
import TextField from "../Common/TextField";
import { useSelector, useDispatch } from "react-redux";
import AssetUploader from "../Common/AssetUploader.js";

import { useActiveCompanyData, } from "hooks/CompanyHooks";
import {pwaItemUpdated} from "../../store/actions/WebchatBrandingElementsAction";
import updateStyling from "utility/PortalPostMessage";

export default function WebchatBrandingTabMenuPWA({ onDataChange = () => {} }) {
    const dispatch = useDispatch();
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);

    const activeCompanyData = useActiveCompanyData();
    const BRAND_HOME_SCREEN_ICON_KEY = "homeScreenIcon";
    const BRAND_NOTIFICATION_ICON_KEY = "notificationIcon";
    const BRAND_LONG_NAME_KEY = "brandLongName";
    const BRAND_SUBDOMAIN_KEY = "SubDomain";
    const BRAND_APP_NAME_KEY = "appName";


    const onAssetUploadCallbackHomeScreenIcon = (uploadedAssetUrl) => {
        if (uploadedAssetUrl === undefined) {
            return;
        }
        updateStyling(document, BRAND_HOME_SCREEN_ICON_KEY, uploadedAssetUrl);
        dispatch(pwaItemUpdated(BRAND_HOME_SCREEN_ICON_KEY, uploadedAssetUrl));
    }

    const onAssetUploadCallbackNotificationIcon = (uploadedAssetUrl) => {
        if (uploadedAssetUrl === undefined) {
            return;
        }
        updateStyling(document, BRAND_NOTIFICATION_ICON_KEY, uploadedAssetUrl);
        dispatch(pwaItemUpdated(BRAND_NOTIFICATION_ICON_KEY, uploadedAssetUrl));
    }

    return (
        <>
            <Row gutter={[10, 10]} style={{ marginLeft: 10 }}>

                <TextField
                    label="Long Form App Name"
                    initialValue={activeCompanyData.name}
                    disabled={true}
                    onChange={(value) => {
                        updateStyling(document, BRAND_LONG_NAME_KEY, value);
                        dispatch(pwaItemUpdated(BRAND_LONG_NAME_KEY, value))
                        onDataChange();
                    }
                    }
                    placeholder={activeCompanyData.name}
                />

                <TextField
                    label="Short App Name"
                    initialValue={activeCompanyData.alias}
                    onChange={(value) => {
                        updateStyling(document, BRAND_SUBDOMAIN_KEY, value);
                        dispatch(pwaItemUpdated(BRAND_SUBDOMAIN_KEY,value))
                        onDataChange();
                    }
                    }
                    placeholder={activeCompanyData.alias}
                />

                <TextField
                    label="Homescreen App Label"
                    onChange={(value) => {
                        updateStyling(document, BRAND_APP_NAME_KEY, value);
                        dispatch(pwaItemUpdated(BRAND_APP_NAME_KEY,value))
                        onDataChange();
                    }
                    }
                    placeholder={previewState[BRAND_APP_NAME_KEY]}
                />
                <div>
                    <h3 style={{ marginBottom: 0, fontWeight: "bold" }}>Home Screen Icon</h3>
                    <AssetUploader currentIconUrl={previewState[BRAND_HOME_SCREEN_ICON_KEY]} hintText={"*Home Screen Icon height and width should not be more than 512x512"} onAssetUploadCallback={onAssetUploadCallbackHomeScreenIcon} />
                </div>
                <div style={{ marginTop: 20 }}>
                    <h3 style={{ marginBottom: 0, fontWeight: "bold" }}>Notification Icon</h3>
                    <AssetUploader currentIconUrl={previewState[BRAND_NOTIFICATION_ICON_KEY]} hintText={"*Notification Icon height and width should not be more than 192x192"} onAssetUploadCallback={onAssetUploadCallbackNotificationIcon} />
                </div>
            </Row>
        </>
    );
}
